var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.trend.length)?_c('Sparkline',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],attrs:{"data":_vm.values,"options":_vm.options,"title":_vm.title},model:{value:(_vm.tooltip),callback:function ($$v) {_vm.tooltip=$$v},expression:"tooltip"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }